export default __webpack_public_path__ + "static/media/instagram.4d969dd1.svg";